import React from 'react'
import Nav from '../Navigation/Nav'

const PurchaseHero = () => {
    return (
        <div className='flex flex-col lg:px-[8%] px-[4%] relative z-[500] text-white'>
            <Nav />
            <div data-aos="zoom-in" className='w-full flex items-center flex-col gap-5 lg:py-[3%] py-[5%]'>
                <p className='text-4xl font-bold text-blue-400'>Purchase Policy</p>
                <div className='flex flex-col lg:w-[80%] w-[98%] lg:gap-10 gap-5 lg:text-xl text-justify'>
                    <ul className='list-disc flex flex-col gap-6'>
                        <li><span className='font-bold'>Warranty:</span> A manufacturer’s warranty is included with all new units. Please refer to the manufacturer’s official website for warranty information.</li>
                        <li><span className='font-bold'>Refunds and exchanges:</span> We do not provide any refunds or exchanges for any equipment purchased from Supreme Mining. For machine concerns, please check with the appropriate ASIC maker.</li>
                        <li>Regarding BTC, we convert BTC to USD to pay for miners, therefore we’d return you depending on the current BTC/USD exchange rate. The USD value at the time of purchase will be used to calculate the refund value.</li>
                        <li><span className='font-bold'>Note 1:</span> The unit hashrate is an estimate; the exact unit hashrate will depend on production. The overall hashrate will not fall below the amount specified on the invoice.</li>
                        <li><span className='font-bold'>Note 2:</span> The price of cryptocurrency mining equipment must be modified often in response to variables such as the cryptocurrency’s fiat exchange rate, the network difficulty of the cryptocurrency, or the predicted difficulty of the cryptocurrency.</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default PurchaseHero